import React from "react";
import "../../ProductDetailCard.css";
import { Button, Flex } from "@chakra-ui/react";

const DetailCard = (props) => {
    const onClickEditButton = () => {
        let pdfFile = props.content;
        let pdfFilePath = pdfFile.split("/");
        let pdfFileName;
        if (pdfFile.includes("pdf")) pdfFileName = pdfFilePath[pdfFilePath.length - 1];

        let image = props.image;
        let imagePath = image.split("/");
        let imageName = imagePath[imagePath.length - 1];

        props.setValue(props.name);
        props.setContent(props.content);
        props.setImgBase64(props.image);
        props.setPdfFileName(pdfFileName);
        props.setImgName(imageName);
        props.setPdf(props.content);
        props.setIsModalOpen(true);
        props.setIsEditMode(true);
        props.setEditId(props.id);
    };

    return (
        <>
            {props.cardType === "1" ? (
                // type 1
                <div className="w-[35vw] m-10">
                    <div className="product_name_above_image">{props.name}</div>
                    <div>
                        <img src={props.image} className="rounded-lg w-[35vw] h-[30vh]" alt="Product Image" style={{objectFit:"contain"}}/>
                        <div className="content_box_type_1 w-[35vw]">{props.content}</div>
                        <Flex>
                            <Button
                                fontSize="3xl"
                                px="10px"
                                py="20px"
                                colorScheme="green"
                                mr={5}
                                onClick={() => onClickEditButton()}
                            >
                                편집
                            </Button>
                            <Button
                                fontSize="3xl"
                                px="10px"
                                py="20px"
                                colorScheme="red"
                                onClick={props.onClickDeleteButton}
                            >
                                삭제
                            </Button>
                        </Flex>
                    </div>
                </div>
            ) : props.cardType === "2" ? (
                // type 2
                <div className="w-[25vw] mx-4 my-5">
                    <div className="product_name_above_image">{props.name}</div>

                    <div className="flex justify-center">
                        <img src={props.image} className="rounded-lg w-[25vw] h-[30vh]" alt="Product Image" />

                    </div>

                    <div className="left-0 w-full mt-[5px]">
                        <div className="flex justify-center">
                            <div
                                className="w-[200px] catalogue_button font-bold"
                                onClick={() => {
                                    window.open(props.content);
                                }}
                            >
                                온라인카다로그
                            </div>
                        </div>
                    </div>
                    
                    <Flex>
                        <Button
                            fontSize="3xl"
                            px="10px"
                            py="20px"
                            colorScheme="green"
                            mr={5}
                            onClick={() => onClickEditButton()}
                        >
                            편집
                        </Button>
                        <Button
                            fontSize="3xl"
                            px="10px"
                            py="20px"
                            colorScheme="red"
                            onClick={props.onClickDeleteButton}
                        >
                            삭제
                        </Button>
                    </Flex>
                </div>
            ) : (
                // type 3
                <div className="w-[80vw] m-10">
                    <div className="product_name_above_image" style={{ marginLeft: 0 }}>
                        {props.name}
                    </div>
                    <div className="flex min-h-[30vh]">
                        <img src={props.image} className="rounded-lg w-[30vw] h-[30vh]" alt="Product Image" />
                        <div className="content_box min-h-[30vh]">{props.content}</div>
                    </div>
                    <Flex>
                        <Button
                            fontSize="3xl"
                            px="10px"
                            py="20px"
                            colorScheme="green"
                            mr={5}
                            onClick={() => onClickEditButton()}
                        >
                            편집
                        </Button>
                        <Button
                            fontSize="3xl"
                            px="10px"
                            py="20px"
                            colorScheme="red"
                            onClick={props.onClickDeleteButton}
                        >
                            삭제
                        </Button>
                    </Flex>
                </div>
            )}
        </>
    );
};

export default DetailCard;
